import React from 'react';
import PrinterSearchBox, { searchPageName, searchPagingParams } from './printerSearchBox';
import SelectYourPrinter from './selectYourPrinter';
import AdPage from './adPage';
import BrandPage from './brandPage';

import { routeInit } from '../actions/routeInitActions';
import { resetForm } from '../actions/formActions';
import { brandSelected, brandPrepopulated } from '../actions/brandActions';
import { deviceSelected } from '../actions/deviceActions';
import { connect } from 'react-redux';
import { parseQueryString } from '../global-functions/parseQueryString';
import { setFinderTypeId } from '../actions/finderTypeIdActions';

class MainRoute extends React.Component {
    constructor(props) {
        super(props);
    }
    componentWillMount() {
        let finderTypeId = this.parseQueryStringForType();

        this.props.routeInit(this.props.match.params, finderTypeId);
    }
    componentDidUpdate(prevProps) {
        let finderTypeId = this.parseQueryStringForType();
        finderTypeId = finderTypeId ? finderTypeId : this.getDefaultFinderTypeId();
        if (this.props.location.search !== prevProps.location.search) {
            if (finderTypeId !== this.props.finderTypeId) {
                this.updateSearchParams(this.props.match.params, finderTypeId);
            }
        }
        if (this.props.history.action === "POP" && this.props.match.params !== prevProps.match.params) {
            if (this.props.match.params.manufacturer) {
                if (this.props.match.params.manufacturer !== prevProps.match.params.manufacturer) {
                    this.props.brandSelected(decodeURIComponent(this.props.match.params.manufacturer), finderTypeId);
                }
                else {
                    this.props.brandPrepopulated(decodeURIComponent(this.props.match.params.manufacturer));
                }
            }
            if (this.props.match.params.device && this.props.match.params.device !== prevProps.match.params.device) {
                this.props.deviceSelected(decodeURIComponent(this.props.match.params.manufacturer), decodeURIComponent(this.props.match.params.device), finderTypeId);
            }
            if (!this.props.match.params.manufacturer && !this.props.match.params.device) {
                this.props.resetForm();
            }
        }
    }
    getDefaultFinderTypeId() {
        const finderTypeIdProp = "Ink and Toner Finder Type";
        return this.props.configPropValues && !this.props.configPropValues[finderTypeIdProp] ? "InkAndTonerMatch" : this.props.configPropValues[finderTypeIdProp];
    }
    updateSearchParams(params, finderTypeId) {
        this.props.routeInit(params, finderTypeId);
        this.props.resetForm();
    }
    parseQueryStringForType() {
        var queryObj = parseQueryString(this.props.location.search);
        return queryObj && queryObj.type ? queryObj.type : null;
    }
    render() {

        return (
            <div>
                <div className="content-wrapper">
                    <div className="grid-container">
                        <div className="row">
                            <div className="col-md-12">
                                <h1 className="maintitle">Ink &amp; Toner Finder</h1>
                                <PrinterSearchBox />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-1"></div>
                            <div className="col-md-11">
                                <div className="solid-line wbmblue">
                                    <span>OR</span>
                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <h3 className="dynamic-vertical-header normaltext">Select Your Printer</h3>
                                <SelectYourPrinter routeMatchParams={this.props.match.params} queryString={this.props.location.search} searchPageName={searchPageName} urlSuffix={searchPagingParams} />
                            </div>
                        </div>
                        <AdPage />
                        <div className="row">
                            <div className="col-md-12">
                                <BrandPage />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        configPropValues: state.configPropValues,
        finderTypeId: state.finderTypeId
    };
}
function mapDispatchToProps(dispatch) {
    return {
        routeInit: (e, finderTypeId) => dispatch(routeInit(e, finderTypeId)),
        resetForm: () => dispatch(resetForm()),
        setFinderTypeId: (e) => dispatch(setFinderTypeId(e)),
        brandSelected: (e, f) => dispatch(brandSelected(e, f)),
        deviceSelected: (e, f, g) => dispatch(deviceSelected(e, f, g)),
        brandPrepopulated: (e) => dispatch(brandPrepopulated(e))
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MainRoute);